import axios from "axios";

import config from "./../config/env";

export const getSignedUrl = (key: string) =>
  axios.get(`${config.API}/getSignedUrl`, { params: { key } });
